import React from 'react';
import BulkExportAction from '../ContactList/BulkActions/BulkExportAction';
import BulkActions from '../ContactList/BulkActions/BulkActions';
import BulkAction from '../ContactList/BulkActions/BulkAction';
import { faSignOut } from '@fortawesome/pro-solid-svg-icons/faSignOut';
import PropTypes from 'prop-types';

const ReportExportButton = ({
  dispatch,
  location,
  ready,
  reportLoading,
  url
}) => {
  const downloadMessage = 'Your file is being prepared. You can safely close this modal and continue working. The '
    + 'report will automatically download when completed and will also be available on the User Jobs page.';

  return <React.Fragment>
    <BulkActions>
      <BulkAction title='Export' icon={faSignOut} disabled={!ready || reportLoading}>
        <BulkExportAction
          title='Download CSV'
          dispatch={dispatch}
          location={location}
          url={`${url}/export.csv`}
          message={downloadMessage}
        />
        <BulkExportAction
          title='Download PDF'
          dispatch={dispatch}
          location={location}
          url={`${url}/export.pdf`}
          message={downloadMessage}
        />
      </BulkAction>
    </BulkActions>
  </React.Fragment>;
}

ReportExportButton.propTypes = {
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  ready: PropTypes.bool.isRequired,
  reportLoading: PropTypes.bool.isRequired
}

export default ReportExportButton;
